import BackgroundImage from '@/components/blocks/Spotlight/BackgroundImage';
import ResponsiveImage from '@/components/ResponsiveImage';
import { cn } from '@/lib/utils';

const Layout = ({ children, hideShape = false, backgroundImage, className }) => {
  return (
    <section className={cn('spotlight-layout relative overflow-clip', className)}>
      <div className='container flex flex-col layout-container'>{children}</div>
      {backgroundImage && hideShape && (
        <ResponsiveImage
          file={backgroundImage}
          priority
          className='absolute inset-0 -z-20 hidden sm:block object-cover h-full'
        />
      )}
      {backgroundImage && !hideShape && <BackgroundImage {...backgroundImage} />}
    </section>
  );
};

export default Layout;
